export default __webpack_public_path__ + "static/media/ic_magnifying_glass.dc911a98.svg";